import $$ from 'cmn-utils'
import config from "./config"
import event from "./event"
import prop from "./prop"
import action from "./action"
import version from "./version"
import part from "./part"


const baseUrl = "/api/sys/product/";
export default {
    delete: (params) => {
        return $$.post(baseUrl + 'delete', params)
    },
    get: (params) => {
        return $$.get(baseUrl + 'get', params)
    },
    list: (params) => {
        return $$.get(baseUrl + 'list', params)
    },
    listAuthorized: (params) => {
        return $$.get(baseUrl + 'list-authorized', params)
    },
    getSubProductList: (params) => {
        return $$.get(baseUrl + 'get-sub-product-list', params)
    },
    getSubProductListAuthorized: (params) => {
        return $$.get(baseUrl + 'get-sub-product-list-authorized', params)
    },
    // listByGateway: (params) => {
    //     return $$.get(baseUrl + 'list-by-gateway', params)
    // },
    // listByUnit: (params) => {
    //     return $$.get(baseUrl + 'list-by-unit', params)
    // },
    // listHome: (params) => {
    //     return $$.get(baseUrl + 'list-home', params)
    // },
    updateAuthorized: (params) => {
        return $$.post(baseUrl + 'update-authorized', params)
    },
    updateIcon: (params) => {
        return $$.post(baseUrl + 'update-icon', params)
    },
    updateIconImage: (params) => {
        return $$.post(baseUrl + 'update-icon-image', params)
    },
    config, event, prop, action, version,part

}